import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from "@src/service";
import { IGetSettingsResponse } from "./types";
import { SettingGroupEntity, SettingUnitType } from '@src/core/features/settings/entities';
import { isUnitType, setUnitType } from '@src/core/features/settings/units';
import { trackError, toTrackedError } from '@src/core/sentry';

export const baseSettingsApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'baseSettingsApi',
  tagTypes: ['Settings', 'Users', 'UserSettings'],
  endpoints: (builder) => ({
    getSettings: builder.query<IGetSettingsResponse, void>({
      query: () => ({
        url: '/api/v1/orders/settings',
        method: 'GET',
      }),
      providesTags: ['Settings'],
      transformResponse(group: SettingGroupEntity[]) {
        return {
          group: group,
          items: group.flatMap((g) => g.items),
        };
      },
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const units = data.items.find((item) => item.key === SettingUnitType.UNITS);
          const unitValue = units?.value;
          if (isUnitType(unitValue)) {
            setUnitType(unitValue);
          }
        } catch (error: unknown) {
          trackError(toTrackedError(error), { code: 'FE_0018', extra: { flow: 'getSettingsQueryFulfilledSideEffect' } });
        }
      }
    })
  }),
});

export const { useGetSettingsQuery } = baseSettingsApi;